import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    background: ['show now - button'],
    button: ['close - button']
  }
};

const BasicFullCountdownTracking: FC = () => {
  const dispatch = useDispatch();

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    a {
      color: #000000;
      text-decoration: none;
      cursor: pointer;
    }

    .root_tracking {
      width: 100%;
      height: 100%;
      position: relative;
    
      .content_wrapper {
        width: 100%;
        height: 100%;
      }

      .close_btn {
        width: 100%;
        position: absolute;
        right: 0;
        top: 6%;
      }
      
      .center {
        width: 100%;
        height: 100%;
        
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
      }

      .title_wrapper {
        width: 100%;
        display: flex;

        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
      }
      .title_wrapper .year {
        width: 100%;
        height: 1.25rem;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .title_wrapper .title {
        width: 100%;
        height: 3rem;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .title_wrapper .sub_title {
        width: 100%;
        height: 4rem;

        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }

      .timer_area {
        width: 100%;
        display: flex;

        flex-direction: column;
        gap: 0.5rem;
      }
      .timer_area .countdown_text {
        width: 100%;
        height: 1.5rem;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .timer_area .timer {
        height: 6.25rem;

        display: grid;
        grid-template-columns: 1fr 1rem 1fr 1rem 1fr;
        justify-content: space-between;
      }

      .btn_bottom {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 2rem;
      }
      .btn_bottom button {
        width: 100%;
        height: 3rem;
        padding: 0 1rem;
        border: none;
        display: block;
        text-align: center;
        background: transparent;
      }
      .btn_bottom .style01 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="content_wrapper">
          <div className="close_btn tracking_center">
            <EditTracking value={tracking?.button?.[0]} type="button" />
          </div>
          <div className="center">
            <div className="title_wrapper">
              <p className="year" />
              <p className="title" />
              <p className="sub_title" />
            </div>

            <div className="timer_area">
              <p className="countdown_text" />
            </div>
          </div>

          <div className="btn_bottom">
            <button className="style01 tracking_center">
              <EditTracking
                value={tracking?.background?.[0]}
                type="background"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicFullCountdownTracking;
